// FileGrid.js
import React from "react";
import FileItem from "./FileItem";

const FileGrid = ({ directoryData, selectedItems, selectionMode, onClick, onContextMenu, toggleSelection, activeTab, onToggleFavorite }) => {
  return (
    <div className="grid grid-cols-1 ms:grid-cols-2 xs:grid-cols-2 ss:grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4 pb-2 overflow-y-auto max-h-[calc(100dvh-7.3rem)]">
      {directoryData.map((item) => (        
        <FileItem
          key={item.id}
          item={item}
          selectedItems={selectedItems}
          selectionMode={selectionMode}
          onClick={() => onClick(item)}
          onContextMenu={(e) => onContextMenu(e, item)}
          toggleSelection={() => toggleSelection(item)}
          activeTab={activeTab}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
};

export default FileGrid;